import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NavigationEnd, Router } from '@angular/router'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { filter } from 'rxjs'

@Component({
  selector: 'ex-app-menu-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-menu-panel.component.html',
  styleUrls: ['./app-menu-panel.component.scss']
})
export class AppMenuPanelComponent implements OnInit {

  @Input() isOpen = false
  @Input() desktopMode: 'inline' | 'dropdown' | 'mobile-only' = 'inline'
  @Output() close = new EventEmitter<void>()

  #router = inject(Router)
  #destroyRef = inject(DestroyRef)

  ngOnInit() {
    this.#router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntilDestroyed(this.#destroyRef)
    ).subscribe(() => this.close.emit())
  }

}
